import React from "react";
import { Row } from "react-table";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const cellProps = (props: any, { cell }: any) =>
  getStyles(props, cell.column.align);

const getStyles = (props: unknown, align = "left") => {
  let justifyContent = "flex-start";

  switch (align) {
    case "right":
      justifyContent = "flex-end";
      break;
    case "center":
      justifyContent = "center";
      break;
  }
  return [
    props,
    {
      style: {
        justifyContent,
        alignItems: "flex-start",
        display: "flex",
      },
    },
  ];
};

export interface TableRowProps<T extends object> {
  row: Row<T>;
}

export function TableRow<T extends object>(props: TableRowProps<T>) {
  const { row } = props;
  const { key: rowKey, ...rowProps } = row.getRowProps();

  return (
    <div key={rowKey} {...rowProps} data-cy={`row-${row.id}`}>
      {row.cells.map((cell) => {
        const { key: cellKey, ...cellPropsRest } = cell.getCellProps(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          cellProps as any
        );
        return (
          <div key={cellKey} {...cellPropsRest} className="td">
            {cell.render("Cell")}
          </div>
        );
      })}
    </div>
  );
}
